//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loadMoreBtn from '@/common/components/load-more-btn/index.vue'
import gameHead from '../components/game-head/index.vue'
import gameList from './item/index.vue'
import Search from '../components/search/index.vue'
import { getHotGamePlatform, getPlatformByPlatCode, getAllGameList, getCollectList } from '@/common/api/game.js'
import { goSlotGame, goGame,goSpecialFishGame, goSpecificGame,fastGoGame} from '@/common/utils/common.js';
import collectMX from './collect-mx.js'
import { mapState } from 'vuex'
import IframeWrap from './iframewrap.vue'

export default {
  components: { Search, loadMoreBtn, gameList, IframeWrap },
  mixins: [collectMX],
  props: {
    gameTypeCode: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      // imgCodes: {
      //   '1': 'GameBannerForSlots',
      //   '2': 'GameBannerForLive',
      //   '3': 'GameBannerForSport',
      //   '4': 'GameBannerForLottery',
      //   '5': 'GameBannerForFish'
      // },
      slotClass: '',


      platformList: [], // 电子的平台列表
      slotTabIndex: 0, // 电子平台
      gameType: '-1', // 游戏类型
      platformCode: null, // 电子平台
      platform: null, // 平台信息 类似电子一样列表显示的是游戏而不是平台
      loadmore: true,
      finish: Function,
      pages: { pageNo: 1, pageSize: 100 },
      list: [],
      total: null,
      queryType: '',
      queryIndex: 0,
      isShowFriendly: false,
      isLoad: false,
      ifrUrl: '',
      ifrTitle: '',
    }
  },
  computed: {
      ...mapState({
          eventPlatFormCode: state => state.eventPlatFormCode
      })
  },
  watch: {
    eventPlatFormCode(newVal, oldVal) {
      if (newVal !== '') {
        const index = this.platformList.findIndex((item)=>{
          return item.platformCode === newVal
        });
        this.slotTabIndex = index
        this.handleSlotPlat(this.platformList[index])
        this.$store.commit('setEventPlatFormCode', '')
      }
    },
    // $route: {
    //     handler(v) {
    //       this.setIfrUrl('')
    //     },
    //     deep: true
    //   }
  },
  created() {
    this.isLoad = true;
    // this.gameType = this.$route.params.id || '-1'
    this.gameType = this.gameTypeCode || '3'
    if (this.gameType === '1' || this.gameType === '6' || this.gameType === '7') this.slotClass = 'slot_'
    if (this.$route.query.platformCode) {
      this.platformCode = this.$route.query.platformCode
    }
    this._getLists() // 获取游戏列表
  },
  methods: {
      setIfrUrl(url) {
        this.ifrUrl = url;
        this.ifrTitle = '';
      },
      setQuery(index, key) {
          if (index === 3 && !this.$store.state.isLogin) {
              this.isShowFriendly = true
              return false
          }
          this.queryIndex = index;
          this.queryType = key;
          if (index === 3) {
              this.handleFav()
          } else {
              this.handleSlotPlat(this.platformList[this.slotTabIndex])
          }
      },
    handleClick({ tabIndex }) { // 导航点击
      this.slotTabIndex = tabIndex
      this.handleSlotPlat(this.platformList[tabIndex])
    },

    handleFav() { // 收藏
      this.pages.pageNo = 1
      this._getFavList()
    },

    handleSlotPlat({ platformCode, maintain, maintainRemarks }) { // 电子平台点击
      this.platformCode = platformCode
      this.platform = { maintain, maintainRemarks }
      this.pages.pageNo = 1
      this._getSlotList()
    },

    async handleGoGame(item) { // 点击游戏
      // popularType 热门类型0=平台，1=游戏
      // 游戏类型:1 - 电子，2-真人，3-体育，4-彩票，5-捕鱼，6-棋牌
      const { gameType, platformKey, platformCode, popularType, gameId, gameName, platformName } = item
      console.log(gameType)
      this.ifrTitle = gameName || platformName || ''
      let lang = 'en'
      if (this.$Cookies.get('lang') === 'hi_IN') lang = 'hi'
      const unlogLinks = { // 未登录游戏嵌套链接
          BBBEXCHANGE:'https://gamet.bbbiframe.com/exchange/in-play',
          IBC2: `https://ismart.l0044.xtu168.com/DepositLogin/bfindex?lang=${lang}&skincolor=rd001`, // 【沙巴体育】
          BTI: `https://prod20144-27818307.1x2aaa.com/${lang}/sports`, // BTI体育
      }

      // if (platformCode === 'BTI') {
      if (platformCode && unlogLinks[platformCode]) {
        const loadingInstance = this.$loading();
        // let gameUrl = this.$store.state.isLogin ? goGame(item, this.$store.state.isLogin, this.$store.state.UUID , 1) : unlogLinks[platformCode]
        // let gameUrl = this.$store.state.isLogin ? await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID , 1) : unlogLinks[platformCode]
        const res = this.$store.state.isLogin ? await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID , 1) : {gameUrl: unlogLinks[platformCode]}
        let gameUrl = res.gameUrl;
        loadingInstance.close();
        if (!gameUrl) {
            this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
            return false
        }
        // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
        this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
        return false
      }

      if (gameType === '4' && platformCode === 'GT') { // 表示跳到彩票
        const type = (platformKey && platformKey.indexOf('GT_LOTTERY_') > -1) ? platformKey.replace('GT_LOTTERY_', '') : '3'
        this.$router.push({ path: '/bet', query: { type } })
        return
      }

      if (this.gameType === '-1' && popularType === '0' && gameType === '1') { // 表示热门列表里面有属于电子的 跳转到电子选项
        this.$router.push({ path: '/game/1', query: { platformCode } })
      } else {
        const { maintain, maintainRemarks } = item // "maintain": "0=没有维护,1=维护中",
        
        if ((gameType === '1' || gameType === '7' || gameType === '6' || gameType === '5') && this.platformCode === '') {  // 如果是电子或者棋牌,且进入 all game 选项
          const itemSel = this.platformList.find((item2)=>{
              return item2.platformCode === platformCode
          })
          if (itemSel) {
              if (itemSel.maintain === '0') {
                  if (this.$store.state.isLogin) {
                    let gameUrl = '';
                    let res = {};
                    const loadingInstance = this.$loading();
                    if(gameType === '1' || gameType === '7'){
                      res = await goSlotGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                      gameUrl = res.gameUrl
                      // this.$router.push({ path: '/game/iframe', query: { ifrUrl:gameUrl } })
                    }else if(gameType === '5'){
                      res = await goSpecialFishGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                      gameUrl = res.gameUrl
                    }else if(gameType === '6'){
                      res = await goSpecificGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                      gameUrl = res.gameUrl
                    }else{
                      // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                      res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                      gameUrl = res.gameUrl
                    }
                    loadingInstance.close();

                      if (!gameUrl) {
                          this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
                          return false
                      }
                      // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
                      this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
                      return false
                  } else {
                      this.$router.push({ path: '/login' })
                  }
              } else {
                  this.$store.commit('setupholdInfo', itemSel.maintainRemarks)
                  this.$store.commit('setupholdShow', true) // 维护弹框
              }
              return false
          }
          
        }
          
        
        if ((!this.platform ? maintain : this.platform.maintain) === '0') {
          if (this.$store.state.isLogin) {
              let gameUrl = '';
              let res = {};
              const loadingInstance = this.$loading();
              if(gameType === '1' || gameType === '7'){
                  res = await goSlotGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                  gameUrl = res.gameUrl
              }else if(gameType === '5'){
                  res = await goSpecialFishGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                  gameUrl = res.gameUrl
              }else if(gameType === '6'){
                  res = await goSpecificGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                  gameUrl = res.gameUrl
              }else if(gameType === '3'){
                if (platformCode === 'JIUW') { //九W游戏外跳
                  loadingInstance.close();
                  goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                }else{
                  // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID) //体育
                  res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //体育
                  gameUrl = res.gameUrl
                }

              }else{
                  // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                  res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                  gameUrl = res.gameUrl
              }
              if (!(gameType === '3' && platformCode === 'JIUW')) {
                loadingInstance.close();
              }
              if (!gameUrl) {
                this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
                  return false
              }
              // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
             this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
              return false
          } else {
            this.$router.push({ path: '/login' })
          }
        } else {
          this.$store.commit('setupholdInfo', !this.platform ? maintainRemarks : this.platform.maintainRemarks)
          this.$store.commit('setupholdShow', true) // 维护弹框
        }
      }
    },

    _getLists() {
      if (this.platformList.length > 0 && this.platformCode) {
        this._getSlotList()
        return
      }
      let _ajax = null
      let params = {}
      if (this.$Cookies.get('UUID')) params.UUID = this.$Cookies.get('UUID')
      if (this.gameType === '-1') { // 热门
        _ajax = getHotGamePlatform
      } else { // 其他
        _ajax = getPlatformByPlatCode
        params = { gameType: this.gameType }
      }
      console.log('this.gameType', this.gameType)
      if (!_ajax) return
      _ajax(params).then(([data, err, res]) => {
        if (!err && data) {
          if (this.gameType === '-1') { // 热门
            this.list = this.showPart ? data.slice(0,10) : data
            // lotteryBuySwitch === '0' 彩票开启 platformCode === 'GT' 为彩票
            if (this.$store.state.linkList.lotteryBuySwitch === '0') this.list = this.list.filter((item) => (item.platformCode !== 'GT'))
            this.total = this.list.length
          } else if (this.gameType === '1' || this.gameType === '7') { // 电子
            this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
            let slotItem = null
            if (this.platformCode) {
              const $index = this.platformList.findIndex((item) =>(item.platformCode === this.platformCode))
              slotItem = this.platformList[$index]
              this.platformList.splice($index, 1)
              this.platformList.unshift(slotItem)
            }
            // this.platformList = this.platformList.slice(0,2)
            if (!slotItem) slotItem = this.platformList[0]
            this.handleSlotPlat(slotItem)
          } else if (this.gameType === '6') {
              this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
              let slotItem = null
              if (this.platformCode) {
                  const $index = this.platformList.findIndex((item) =>(item.platformCode === this.platformCode))
                  slotItem = this.platformList[$index]
                  this.platformList.splice($index, 1)
                  this.platformList.unshift(slotItem)
              }
              // this.platformList = this.platformList.slice(0,2)
              if (!slotItem) slotItem = this.platformList[0]
              this.handleSlotPlat(slotItem)
          }else if (this.gameType === '5') {
              this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
              let slotItem = null
              if (this.platformCode) {
                  const $index = this.platformList.findIndex((item) =>(item.platformCode === this.platformCode))
                  slotItem = this.platformList[$index]
                  this.platformList.splice($index, 1)
                  this.platformList.unshift(slotItem)
              }
              // this.platformList = this.platformList.slice(0,2)
              if (!slotItem) slotItem = this.platformList[0]
              this.handleSlotPlat(slotItem)
          } else { // 其他
            this.list = data.list
            this.total = data.total
          }
        }
      })
    },

    loadMoreData({ finish }) { // 加载更多
      this.pages.pageNo += 1
      this.finish = finish
      if (this.gameType === '1' || this.gameType === '7'){
          this._getSlotList() // 电子
      }
    },

    _getSlotList(keyword) { // 获取电子列表
      if (keyword !== undefined || keyword === false) this.pages.pageNo = 1
      const params = { gameType: this.gameType, platformCode: this.platformCode, ...this.pages, hotOrNew: this.queryType }
      if (this.$store.state.isLogin) params.UUID = this.$store.state.UUID
      if (keyword && keyword.length > 0) {
        params.keyword = keyword
        this.pages.pageNo = 1
      }
      if (this.pages.pageNo === 1) this.loadmore = true

      getAllGameList(params).then(([data, err, res]) => {
        this.finish()
        if (!err) {
          const { list, total } = data
          this.list = this.pages.pageNo === 1 ? list : [...this.list, ...list]
          this.total = total
          this.loadmore = this.list.length < this.total
        } else {
          if (this.pages.pageNo === 1) {
            this.list = []
            this.total = 0
          }
          this.loadmore = false
        }
      })
    },

    _getFavList(keyword) {
        const params = { ...this.pages }
        if (this.$store.state.isLogin) params.UUID = this.$store.state.UUID
        if (keyword && keyword.length > 0) {
          params.keyword = keyword
          this.pages.pageNo = 1
        }
        if (this.pages.pageNo === 1) this.loadmore = true

      getCollectList(params).then(([data, err, res]) => {
      //   this.finish()
        if (!err) {
          const { list, total } = data
          list.map((item)=>{
              item.isCollect = '1'
          })
          this.list = this.pages.pageNo === 1 ? list : [...this.list, ...list]
          this.total = total
          this.loadmore = this.list.length < this.total
        } else {
          if (this.pages.pageNo === 1) {
            this.list = []
            this.total = 0
          }
          this.loadmore = false
        }
      })
    },

    handleCollect({ gameType, platformCode, gameId, id, popularType, isCollect, platformId, slotId }, index) { // isCollect === 1 收藏 收藏或取消收藏
      if (!this.$store.state.isLogin) { // 未登录状态
        this.$router.push({ path: '/login' })
        return
      }

      // console.log(platformId, slotId)
      let params = { UUID: this.$store.state.UUID }
      //  type 1=游戏 2=平台  popularType 热门类型0=平台，1=游戏
      params.type = (gameType === '1'|| gameType === '7') ? 1 : 2
      if (popularType) params.type = popularType === '0' ? 2 : 1
      params.targetId = id
      if (gameType === '5') { // 对捕鱼的再做处理
        params.targetId = !gameId ? id : gameId
        params.type = !gameId ? 2 : 1
      }
      if (this.gameType === '-1') params.targetId = popularType === '0' ? platformId : slotId
      if (isCollect === '1') {
        this.handleCancelCollect(params, index)
      } else {
        this.handleAddCollect(params, index)
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/build821/views/game/index.vue